import {ADDRESS_FETCH_COMPLETED, ADDRESS_FETCH_STARTED} from "../constants/Address";
import {Address} from "../../../../models/Address";

interface AddressState {
  addresses: Address[];
  hasLoaded: boolean;
  isFetching: boolean;
}

const initialState: AddressState = {
  addresses: [],
  hasLoaded: false,
  isFetching: false
};

export function addresses(state = initialState, action) {
  switch (action.type) {
    case ADDRESS_FETCH_STARTED:
      return {...state, isFetching: true};
    case ADDRESS_FETCH_COMPLETED:
      return {...state, addresses: action.addresses, hasLoaded: true, isFetching: false};
    default:
      return state;
  }
}
